<template>

<div>

    <section class="page-banner page-banner-sec">
        <h1 class="section-title">{{ $t('confirm_account.header') }}</h1>
    </section>

    <div id="layout-content" class="pt-4">

        <div class="container">

            <h2>{{ $t('confirm_account.title') }}</h2>

            <div class="alert alert-danger alert-styled-left" v-if="!confirmed" v-html="$t('confirm_account.not_confirmed')"></div>
            <div class="alert alert-success alert-styled-left alert-arrow-left" v-else v-html="$t('confirm_account.confirmed')"></div>

            <p class="mt-3"><router-link :to="{ name: 'login' }" class="btn btnSubmit btn-secondary p-2" tag="button">{{ $t('login.back') }}</router-link></p>

        </div>

    </div>

</div>

</template>

<script>
// Vuex Stores
import { mapActions, mapGetters } from 'vuex'

// Common OTU Components
import { EventBus, mapNotificationEventActions } from '@/lib/events.js';

export default {
	name: 'AccountConfirm',
	data () {
		return {
            confirmed: true
        }
	},
	created () {
        this.userConfirm(this.$route.params.hash).then((v) => {
            this.confirmed = v;
        }).catch((err) => {
            this.confirmed = false;
        });
    },
	methods: {
		...mapActions(['userConfirm']),
		...mapNotificationEventActions
	}
}
</script>
